import type { Invoice } from "@nlc/shared-types";

import { toast } from "@/components/toast/toast-queue";

import { buildInvoiceLink } from "../utils/invoice-format";

export function useCopyInvoiceLink(
  projectId: number,
): (invoice: Invoice) => Promise<void> {
  return async (invoice: Invoice) => {
    await navigator.clipboard.writeText(
      buildInvoiceLink(projectId, invoice.id),
    );

    toast.add({
      description: "The invoice link has been copied to your clipboard.",
      timeout: 2000,
      title: "Link copied",
      type: "success",
    });
  };
}
